"use strict";

/**
 * Shared DataDog RUM configuration constants
 *
 * These constants are used across multiple packages:
 * - @autoguru/logs/datadog (browser-side RUM initialization)
 * - @autoguru/aws-lambda-app-shell-html-generator (CDN failure tracking)
 *
 * Centralizing these values ensures consistency and prevents configuration drift.
 */

/**
 * DataDog RUM Application ID
 * Identifies the AutoGuru MFE Portals application in DataDog
 */
export const DATADOG_APPLICATION_ID = '683ef0cc-3951-45b7-ab78-65d2ed57e344';

/**
 * DataDog RUM Client Token (Public)
 *
 * This token is designed to be public and safe to expose in browser code.
 * It only allows sending logs/metrics, not reading data or modifying configuration.
 *
 * Security Best Practice: Rotate this token regularly even though permissions are limited.
 */
export const DATADOG_CLIENT_TOKEN = 'pub76c5c96f3b3c38beced100a20853c001';

/**
 * DataDog Site Region
 * AutoGuru uses the Asia-Pacific 2 region
 */
export const DATADOG_SITE = 'ap2.datadoghq.com';

/**
 * Service Name in DataDog
 * Used to group and filter logs/metrics across all AutoGuru MFE portals
 */
export const DATADOG_SERVICE = 'autoguru-mfe-portals';